<div class="reset-drawer-wrapper">
  <div class="reset-drawer-overlay" *ngIf="isOpen" (click)="onBackdropClick()"></div>

  <div class="reset-drawer-container" *ngIf="isOpen" [@slideIn] (keydown)="closeOnEscape($event)" #drawerElement tabindex="-1">
    <!-- Header -->
    <div class="reset-drawer-header">
      <h3 class="drawer-title">⚙️ {{ 'reset_prefs.title' | translate }}</h3>
      <button class="close-btn" (click)="close()" [title]="'reset_prefs.close_btn' | translate" [attr.aria-label]="'reset_prefs.close_btn' | translate">
        ✕
      </button>
    </div>

    <!-- Content -->
    <div class="reset-drawer-content" *ngIf="resetOptions.length > 0">
      <p class="reset-info">{{ 'reset_prefs.info' | translate }}</p>

      <div class="reset-options">
        <div *ngFor="let option of resetOptions" class="reset-option">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [checked]="isOptionChecked(option.key)"
              (change)="toggleOption(option.key)"
              class="reset-checkbox"
              [attr.aria-label]="getOptionLabel(option.key)"
            />
            <span class="option-label">
              <span *ngIf="option.icon" class="option-icon">{{ option.icon }}</span>
              {{ getOptionLabel(option.key) }}
            </span>
          </label>
          <p class="option-description">{{ getOptionDescription(option.key) }}</p>
        </div>
      </div>
    </div>

    <div class="reset-drawer-empty" *ngIf="resetOptions.length === 0">
      <p>{{ 'reset_prefs.no_options' | translate }}</p>
    </div>

    <!-- Footer -->
    <div class="reset-drawer-footer">
      <button class="btn-secondary" (click)="resetAllToDefaults()" [disabled]="loading">
        🔄 {{ 'reset_prefs.reset_default' | translate }}
      </button>
      <button class="btn-primary" (click)="savePreferences()" [disabled]="loading">
        <span *ngIf="loading">{{ 'reset_prefs.saving' | translate }}</span>
        <span *ngIf="!loading">✓ {{ 'reset_prefs.save' | translate }}</span>
      </button>
    </div>
  </div>
</div>
